/**
 * Copyright 2019-2021 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS.
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */
import getFQDN from '@forgerock/platform-shared/src/utils/getFQDN';

const defaultState = {
  amBaseURL: '',
  idmBaseURL: '',
  fraasLoggingKeyURL: null,
  googleMapsApiKey: '',
  returnRoute: '',
  returnRouteText: '',
};

const mutations = {
  setBaseURLs(state, env) {
    if (env.VUE_APP_AM_URL) {
      state.amBaseURL = getFQDN(env.VUE_APP_AM_URL);
    }

    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.account.ct.gov') > 0) {
      state.idmBaseURL = 'https://dev.account.ct.gov/openidm'; 
    } else if (locationUrl.indexOf('devc.account.ct.gov') > 0) {
      state.idmBaseURL = 'https://devc.account.ct.gov/openidm';
    } else if (locationUrl.indexOf('stg.account.ct.gov') > 0) {
      state.idmBaseURL = 'https://stg.account.ct.gov/openidm';
    } else if (locationUrl.indexOf('psup.account.ct.gov') > 0) {
      state.idmBaseURL = 'https://psup.account.ct.gov/openidm';
    } else if (locationUrl.indexOf('account.ct.gov') > 0) {
      state.idmBaseURL = 'https://account.ct.gov/openidm';
    }

    // if (env.VUE_APP_IDM_URL) {
    //   state.idmBaseURL = getFQDN(env.VUE_APP_IDM_URL);
    // }

    if (env.VUE_APP_FRAAS === 'true') {
      if (env.VUE_APP_FRAAS_LOGGING_URL) {
        state.fraasLoggingKeyURL = env.VUE_APP_FRAAS_LOGGING_URL;
      }
    }

    if (env.VUE_APP_GOOGLE_MAPS_API_KEY) {
      state.googleMapsApiKey = env.VUE_APP_GOOGLE_MAPS_API_KEY;
    }
  },

  setReturnRoute(state, newValue) {
    if (newValue.returnRoute || newValue.returnRoute === '') {
      state.returnRoute = newValue.returnRoute;
    }

    if (newValue.returnRouteText || newValue.returnRouteText === '') {
      state.returnRouteText = newValue.returnRouteText;
    }
  },
};

export default {
  state: defaultState,
  mutations,
};
